import type { SpawnOptions } from 'node:child_process';

/**
 * How preview-environment OS processes relate to the bridge CLI.
 *
 * - `child` (default): spawned attached to the bridge; stopped on bridge shutdown/stop.
 * - `detached` (future): outlives the bridge; not yet exposed via bridge config.
 */
export type PreviewEnvironmentProcessLifecycle = 'child' | 'detached';

export const DEFAULT_PREVIEW_ENVIRONMENT_PROCESS_LIFECYCLE: PreviewEnvironmentProcessLifecycle = 'child';

/** Spawn options merged into every preview-environment `spawn` call. */
export function previewEnvironmentSpawnOptions(
  lifecycle: PreviewEnvironmentProcessLifecycle = DEFAULT_PREVIEW_ENVIRONMENT_PROCESS_LIFECYCLE,
): Pick<SpawnOptions, 'detached'> {
  return { detached: lifecycle === 'detached' };
}
